import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { loginUser } from "../services/gurukulService";
import "../styles/Login.css";
import logo from "../assets/images/logoJ.jpeg"; // Add your logo here

const Login = () => {
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const response = await loginUser(userId, password);

      if (response.userId) {
        localStorage.setItem("userId", response.userId); // Store user session
        navigate("/dashboard"); // Navigate to dashboard on success
      } else {
        setError("Invalid credentials, please try again.");
      }
    } catch (error) {
      setError("Login failed. Please check your credentials.");
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        {/* Right Side - Logo & Name */}
        <div className="logo-container">
          <img src={logo} alt="Shri Kheteshwar Gurukul Logo" />
          <p className="gurukul-name">श्री खेतेश्वर गुरुकुल</p>
        </div>
        
        {/* Left Side - Login Form */}
        <div className="login-form-container">
          <h2 className="login-title">Login Portal - SKG</h2>
          {error && <p className="error-message">{error}</p>}

          <form onSubmit={handleLogin}>
            <div className="input-group">
              <label>User ID</label>
              <input
                type="text"
                value={userId}
                onChange={(e) => setUserId(e.target.value)}
                placeholder="Enter your User ID"
                required
              />
            </div>

            <div className="input-group">
              <label>Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                required
              />
            </div>

            <button type="submit" className="login-btn">Login</button>
          </form>
        </div>

        
      </div>
    </div>
  );
};

export default Login;
